export default __webpack_public_path__ + "static/media/tommy.93ee6e9e.png";